<div>
  <slot></slot>
</div>

<style>
div{
  margin: 2em 1em;
}
</style>